import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { Formik, Form, ErrorMessage } from "formik";
import Button from "../../../atoms/buttons/Button";
import Modal from "react-bootstrap/Modal";
import { memo } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import {
  SpinnerCircle,
  SpinnerCircleMini,
} from "../../../atoms/spinner/Spinner";
import { getYears } from "../../../services/IRPFService";
import SubTituloResMini from "../../../atoms/subTitles/SubTituloResMini";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import ButtonCard from "../../../atoms/buttons/ButtonCard";

registerLocale("es", es);

const ConsultaIRPFHabi = (object) => {
  const [token] = useLocalStorage("token", "");
  // const [user] = useLocalStorage("user", "");
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(true);
  const [years, setYears] = useState([]);
  // const [yearSelect, setYearSelect] = useState(0);
  const [showFeedback, setShowFeedback] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(false);
  const navigate = useNavigate()
  // const handleChangeYear = (e) => {
  //   if (e !== null) {
  //     setYearSelect(e.value);
  //   } else {
  //     setYearSelect(null);
  //   }
  // };

  useEffect(() => {
    if (!isInitialRender) {
      setIsInitialRender(true);
      getYears(token).then((data) => {
        let anyos = data.filter(item => item.value > 2020);
        setYears(anyos);
        if (!data.toString().startsWith("Error:")) {
          setLoading(true);
        }
      });
    }
  }, [isInitialRender, token, years]);

  function modalConsultaIRPFHabiilitado() {
    return (
      <Modal
        className="infModal fechas"
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Consulta Certificado IRPF por las habilitaciones"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Consulta Certificado IRPF por las habilitaciones</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
            <Formik
              enableReinitialize={true}
              initialValues={{
                year: years[0]?.value ?? null
              }}
              validate={(valores) => {
                // valores.year = yearSelect;
                const errores = {};
                if (valores.year == null || valores.year === 0) {
                  errores.year = "Por favor, seleccione un año";
                }
                return errores;
              }}
              onSubmit={(valores) => {
                setLoadingButton(true);

                setShowFeedback(false);

                localStorage.setItem("anyoIRPFHabilitado", valores.year);
                navigate("/irpfHabilitado", { state: { anyo: valores.year } })

                object.handleClose();
              }}
            >
              {({ errors, setFieldValue, values }) => (
                <>
                  <Form>
                    <div className="container">
                      <div className="row align-items-start">
                        {loading ? (
                          <>
                            <div className="row col-xl-9 pb-xl-4">
                              <label htmlFor="year">
                                <SubTituloResMini nombre="Año"></SubTituloResMini>
                              </label>
                              <Select
                                id="year"
                                name="year"
                                options={years}
                                className="selectYear"
                                placeholder="Año"
                                isClearable
                                defaultValue={years[0]}
                                onChange={(option) => {


                                  setFieldValue("year", option ? option.value : null); // ✔ Formik actualiza        // ✔ tu estado también
                                  setShowFeedback(false);                              // ✔ oculta tu error custom
                                }}
                              />

                              {showFeedback ? (
                                <>
                                  <div className="error rojo fs-4 pt-2">
                                    {`Error al cargar el PDF del año ${values.year}`}
                                  </div>
                                </>
                              ) : null}
                              <ErrorMessage
                                name="year"
                                component={() => (
                                  <div className="error rojo fs-4 pt-2">
                                    {errors.year}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="row mt-3 justify-content-center pt-3 col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12">
                              <div className="col align-self-end col-xxl-6 col-xl-6 col-lg-6 cold-md-6 cold-sm-6">
                                <ButtonCard
                                  id="consultaIRPF"
                                  clases="btn-card"
                                  disabled={!loadingButton}
                                  nombre={
                                    loadingButton ? (
                                      <>
                                        <i className="fa-solid fa-eye"></i>{" "}
                                        Consultar
                                      </>
                                    ) : (
                                      <>
                                        <div className="d-flex justify-content-center">
                                          <SpinnerCircleMini
                                            clases={"background-border"}
                                          ></SpinnerCircleMini>
                                        </div>
                                      </>
                                    )
                                  }
                                  tipo="submit"
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <span>
                              {years.length === 0 ? <SpinnerCircle /> : null}
                            </span>
                            <div className="error rojo fs-4 pt-2">
                              {years !== undefined ? years : null}
                            </div>
                            {years.length !== 0 ? (
                              <>
                                <div className="row justify-content-center pt-3">
                                  <Button
                                    id="btnCerrarConsultaIRPF"
                                    clases="btn-card"
                                    nombre="Cerrar"
                                    tipo="button"
                                    funcion={() => {
                                      object.handleClose();
                                    }}
                                  />
                                </div>
                              </>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalConsultaIRPFHabiilitado()}</>;
};

export default memo(ConsultaIRPFHabi);
